import ImageOne from "../images/img20.jpg";
// import ImageTwo from "../images/img10.jpg";
// import ImageThree from "../images/img11.jpg";
// import ImageFour from "../images/img14.jpg";
// import ImageFive from "../images/img5.jpg";
// import ImageSix from "../images/img6.jpg";
// import ImageSeven from "../images/img7.jpg";

export const SliderData = [
  {
    title: "Welcome to Hanna, Mitchell & Associates",
    // price: "$4280000",
    // path: "/homes",
    // label: "View Home",
    image: ImageOne,
    alt: "Handshake",
  },
  // {
  //   title: "House in San Jose, Costa Rica",
  //   price: "$2860000",
  //   path: "/homes",
  //   label: "View Home",
  //   image: ImageTwo,
  //   alt: "House",
  // },
  // {
  //   title: "House in Calabasas, California",
  //   price: "$8420000",
  //   path: "/homes",
  //   label: "View Home",
  //   image: ImageThree,
  //   alt: "House",
  // },
  // {
  //   title: "House in Houston, Texas",
  //   price: "$6660000",
  //   path: "/homes",
  //   label: "View Home",
  //   image: ImageFour,
  //   alt: "House",
  // },
];

// export const SliderDataTwo = [
//   {
//     title: "House in Las Vegas, Nevada",
//     price: "$8980000",
//     path: "/homes",
//     label: "View Home",
//     image: ImageFive,
//     alt: "House",
//   },
//   {
//     title: "House in Houston, Texas",
//     price: "$3,460,000",
//     path: "/homes",
//     label: "View Home",
//     image: ImageSix,
//     alt: "House",
//   },
//   {
//     title: "House in Alajuela, Costa Rica",
//     price: "$8420000",
//     path: "/homes",
//     label: "View Home",
//     image: ImageSeven,
//     alt: "House",
//   },
// ];
